export const route = {
    params: { jobId: 'jobId' },
    patterns: {
        job: {
            create: '/jobs/create',
            details: '/jobs/:jobId',
            edit: '/jobs/:jobId/edit',
        },
        jobs: '/jobs',
    },
    searchParams: {
        owner: 'owner',
        removeShortListCandidate: 'removeShortListCandidate',
        searchTerm: 'searchTerm',
        shortList: 'shortlist',
        skillsSearchTerm: 'skillsSearch',
        tab: 'tab',
        workspaceFilter: 'workspaceFilter',
    },
};

export const jobPageUrl = (jobId: string): string => route.patterns.job.details.replace(':jobId', jobId);

export const jobEditPageUrl = (jobId: string): string => route.patterns.job.edit.replace(':jobId', jobId);
